import ENVIRONMENT from '@constants/internalEnv.constant';

const API_BASE =
  ENVIRONMENT === 'development' ? 'api/icons/v1/web' : 'icons/v1/web';

export const ICONS_ANYFEED = `${API_BASE}/anyfeed`;

export const ICONS_ANYFEED_DETAIL = `${API_BASE}/anyfeed/{uuid}`;

export const ICONS_COURSE_DETAIL = `${API_BASE}/courses/{course_slug}`;

export const ICONS_COURSE_LESSONS = `${API_BASE}/courses/{course_slug}/lessons`;

export const ICONS_COURSE_LESSON = `${API_BASE}/courses/{course_slug}/lessons/{slug}`;

export const ICONS_SIMILAR_COURSES = `${API_BASE}/courses/{course_slug}/similar`;

export const ICONS_LESSON_UUID = `${API_BASE}/lessons/{uuid}`;

export const ICONS_LESSON_BREAKDOWN = `${API_BASE}/lessons/{uuid}/static-breakdowns`;

export const ICONS_LESSON_VIEW = `${API_BASE}/user/lessons/{uuid}/view`;

export const ICONS_LESSON_SUBSCRIPTION = `${API_BASE}/user/subscription/confirm`;

export const ICONS_NOTIFY_USER = `${API_BASE}/user/launch-event-notify`;

export const ICONS_USER_DETAILS = `${API_BASE}/user/details`;

export const ICONS_QUIZ_ANSWER = `${API_BASE}/user/assetquestions/{uuid}/answer`;
